import CollapsedDrawer from './collapsed/collapsed';
import ExpandedDrawer from './expanded/expanded';
import { AiScribeProvider } from './expanded/useAiScribe';

const AiScribeDrawer = () => {
  return (
    <AiScribeProvider>
      <CollapsedDrawer />
      <ExpandedDrawer />
    </AiScribeProvider>
  );
};

export default AiScribeDrawer;
